export const HEADER_OFFSET: number = 40 as const
export const COVERAGE_SECTION_HEIGHT: number = 144 as const
export const COVERAGE_SECTION_MAX_HEIGHT: number = 400 as const
export const COVERAGE_SECTION_MIN_HEIGHT: number = 0 as const
export const DEBOUNCE_DELAY: number = 500 as const
export const COVERAGE_SECTION_EXPAND: number = 30 as const
export const RESIZE_TRACKING_GAP: number = 6 as const
